import React from 'react';

import { Loading } from 'src/components/atoms/Loading/Loading';
import { AlreadyApplied } from 'src/components/molecules/AlreadyApplied/AlreadyApplied';
import type { SignupProps } from 'src/components/organisms/Signup/Signup';
import { Signup } from 'src/components/organisms/Signup/Signup';
import { useUserAppliedState } from './hooks/useUserAppliedState';

export const PartnerApplication = (props: SignupProps) => {
  const { applied, errorMessage, status } = useUserAppliedState();

  if (status === 'idle' || status === 'loading') {
    return <Loading />;
  } else if (status === 'error') {
    return <>{errorMessage}</>;
  }
  return applied ? <AlreadyApplied /> : <Signup {...props} />;
};
